export const COMMERCE_ONBOARDING_CATEGORY_IDS = [16, 9, 3, 12] as const;

export function userSkillIdsMatchCommerceCategories(
  skillIds: number[],
  catalog: { id: number; categoryId: number }[]
): boolean {
  if (!skillIds.length || !catalog.length) return false;
  const allowed = new Set<number>(COMMERCE_ONBOARDING_CATEGORY_IDS);
  for (const sid of skillIds) {
    const sk = catalog.find((s) => s.id === sid);
    if (sk && allowed.has(sk.categoryId)) return true;
  }
  return false;
}
